module.exports = __webpack_public_path__ + "media/chat-message.76631dd8.mp3";